import React from 'react';
import { X, FileText, CheckCircle2, AlertCircle, Info } from 'lucide-react';

interface CsvHelpModalProps {
  isOpen: boolean;
  onClose: () => void;
  theme: 'dark' | 'light';
}

const CsvHelpModal: React.FC<CsvHelpModalProps> = ({ isOpen, onClose, theme }) => {
  if (!isOpen) return null;

  const themeClasses = {
    overlay: "fixed inset-0 bg-black/80 backdrop-blur-sm z-[200] flex items-center justify-center p-4 animate-in fade-in duration-300",
    container: `${theme === 'dark' ? 'bg-[#161616] border-[#262626]' : 'bg-white border-slate-200'} border w-full max-w-lg rounded-3xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200`,
    textMain: theme === 'dark' ? 'text-white' : 'text-slate-900',
    textMuted: theme === 'dark' ? 'text-slate-400' : 'text-slate-500',
    code: theme === 'dark' ? 'bg-black/40 text-indigo-400' : 'bg-slate-100 text-indigo-600',
  };

  return (
    <div className={themeClasses.overlay} onClick={onClose}>
      <div className={themeClasses.container} onClick={e => e.stopPropagation()}>
        <div className="p-8">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-indigo-600 rounded-xl">
                <FileText size={24} className="text-white" />
              </div>
              <h2 className={`text-xl font-black uppercase tracking-tight ${themeClasses.textMain}`}>Formato CSV Requerido</h2>
            </div>
            <button onClick={onClose} className="p-2 hover:bg-white/5 rounded-full transition-colors">
              <X size={20} className={themeClasses.textMain} />
            </button>
          </div>

          <div className="space-y-6">
            <div>
              <p className={`${themeClasses.textMuted} text-sm mb-4`}>
                El sistema detecta automáticamente el formato de exportación estándar. Asegúrese de que las columnas sigan este orden exacto:
              </p>
              <div className={`p-4 rounded-xl font-mono text-[11px] overflow-x-auto ${themeClasses.code}`}>
                Date, Token, Type, Price (USD), Amount, Total value (USD)
              </div>
            </div>

            <div className="space-y-3">
                <div className="flex items-start space-x-3">
                    <CheckCircle2 size={16} className="text-emerald-500 mt-0.5 flex-shrink-0" />
                    <div>
                        <span className={`block text-xs font-black uppercase ${themeClasses.textMain}`}>Columna Type (Tipo)</span>
                        <span className={`${themeClasses.textMuted} text-[11px]`}>Soporta valores como <code className="font-bold">"buy"</code>, <code className="font-bold">"sell"</code>, "Compra" o "Venta".</span>
                    </div>
                </div>
                <div className="flex items-start space-x-3">
                    <CheckCircle2 size={16} className="text-emerald-500 mt-0.5 flex-shrink-0" />
                    <div>
                        <span className={`block text-xs font-black uppercase ${themeClasses.textMain}`}>Formato de Fecha</span>
                        <span className={`${themeClasses.textMuted} text-[11px]`}>Soporta <code className="font-bold">YYYY-MM-DD HH:MM:SS</code> o <code className="font-bold">DD/MM/YYYY</code>.</span>
                    </div>
                </div>
                <div className="flex items-start space-x-3">
                    <AlertCircle size={16} className="text-amber-500 mt-0.5 flex-shrink-0" />
                    <div>
                        <span className={`block text-xs font-black uppercase ${themeClasses.textMain}`}>Encabezados</span>
                        <span className={`${themeClasses.textMuted} text-[11px]`}>La primera fila del archivo debe contener los nombres de las columnas.</span>
                    </div>
                </div>
            </div>

            <div className={`mt-6 p-4 rounded-xl border border-indigo-500/20 bg-indigo-500/5`}>
                <div className="flex items-center space-x-2 mb-2 text-indigo-500">
                    <Info size={14} />
                    <span className="text-[10px] font-black uppercase tracking-widest">Ejemplo de Fila</span>
                </div>
                <p className="font-mono text-[10px] text-slate-500">
                    2024-12-02 22:40:00, ALGO, sell, 0.5391, 46.00, 24.80
                </p>
            </div>
          </div>

          <button 
            onClick={onClose}
            className="w-full mt-8 py-4 bg-indigo-600 hover:bg-indigo-500 text-white rounded-2xl font-black uppercase text-[10px] tracking-widest transition-all shadow-lg shadow-indigo-600/20"
          >
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
};

export default CsvHelpModal;